import { render, staticRenderFns } from "./NumberValue_2.vue?vue&type=template&id=1bea1868&scoped=true&"
import script from "./NumberValue_2.vue?vue&type=script&lang=js&"
export * from "./NumberValue_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea1868",
  null
  
)

export default component.exports